"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PartnerUser = void 0;
class PartnerUser {
  constructor(id, created, email, username, lastActivity, isAdmin, permissions) {
    this.id = id;
    this.created = created;
    this.email = email;
    this.username = username;
    this.lastActivity = lastActivity;
    this.isAdmin = isAdmin;
    this.permissions = permissions;
  }
  get isGeovelo() {
    return this.email.indexOf('@geovelo.fr') > -1;
  }
}
exports.PartnerUser = PartnerUser;